module.exports = __webpack_public_path__ + "static/img/penny_pictgrid22_960x861.9457065.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/penny_pictgrid22_960x861.jpg
// module id = V2u+
// module chunks = 0